import { render, staticRenderFns } from "./DeliverableAssets.vue?vue&type=template&id=29aef8bc&scoped=true"
import script from "./DeliverableAssets.vue?vue&type=script&lang=js"
export * from "./DeliverableAssets.vue?vue&type=script&lang=js"
import style0 from "./DeliverableAssets.vue?vue&type=style&index=0&id=29aef8bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29aef8bc",
  null
  
)

export default component.exports